<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { reactiveOmit } from '@vueuse/core';
    import {
        AlertDialogContent,
        type AlertDialogContentEmits,
        type AlertDialogContentProps,
        AlertDialogOverlay,
        AlertDialogPortal,
        useForwardPropsEmits,
    } from 'reka-ui';
    import { cn } from '@/lib/utils';

    const props = defineProps<AlertDialogContentProps & { class?: HTMLAttributes['class'] }>();
    const emits = defineEmits<AlertDialogContentEmits>();

    const delegatedProps = reactiveOmit(props, 'class');

    const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
    <AlertDialogPortal>
        <AlertDialogOverlay
            data-slot="alert-dialog-overlay"
            class="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 bg-modal-overlay/50 fixed inset-0 z-50 flex items-center justify-center"
        >
            <AlertDialogContent
                data-slot="alert-dialog-content"
                v-bind="forwarded"
                :class="
                    cn(
                        'bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed z-50 grid w-full max-w-[calc(100%-2rem)] rounded-lg shadow-lg duration-200 sm:max-w-lg',
                        props.class,
                    )
                "
            >
                <slot />
            </AlertDialogContent>
        </AlertDialogOverlay>
    </AlertDialogPortal>
</template>
